import classNames from 'classnames';
import { HtmlHTMLAttributes } from 'react';
import { ButtonPrimary, PageLayout, SearchInput } from '../../../../../components';
import { useNegociacoesSalvas } from './NegociacoesSalvas.hooks';
import styles from './NegociacoesSalvas.module.scss';
import { NegociacoesSalvasFilters, TableNegociacoesSalvas } from './components';

export type NegociacoesSalvasProps = HtmlHTMLAttributes<HTMLDivElement>;

export const NegociacoesSalvas = ({ className, ...props }: NegociacoesSalvasProps) => {
  const { search, filters, table, onNewNegotiation } = useNegociacoesSalvas();

  return (
    <PageLayout className={classNames(styles['negociacoes-salvas'], className)} {...props}>
      <PageLayout.Header className={styles['negociacoes-salvas__header']}>
        <PageLayout.Section>
          <PageLayout.Title>Negociações salvas</PageLayout.Title>
          <div className={styles['negociacoes-salvas__header-actions']}>
            <SearchInput className={styles['negociacoes-salvas__search']} {...search} />
            <ButtonPrimary className={styles['negociacoes-salvas__new-negotiation-button']} onClick={onNewNegotiation}>
              nova negociação
            </ButtonPrimary>
          </div>
        </PageLayout.Section>
      </PageLayout.Header>
      <PageLayout.Section>
        <NegociacoesSalvasFilters {...filters} />
      </PageLayout.Section>
      <TableNegociacoesSalvas {...table} />
    </PageLayout>
  );
};
